export function fromDotNotation(obj: any, key: string) {
    return key.split('.').reduce((previous: any, current: any, index: number) => {
        return previous!= null ?previous[current]: null;
    }, obj);
}